import axios, { AxiosInstance } from 'axios';
import { createCustomInterceptorInstance } from '@fundacao/shared-components/esm/ie/renovacao';


class UserInfoService {
  private http: AxiosInstance;
  documentApi = process.env.REACT_APP_DOCUMENTS_API;
  userSession = process.env.REACT_APP_USER_SESSION_API;
  constructor() {
    this.http = axios.create({});
    this.http.defaults.headers.common.Authorization = `${localStorage.getItem(
      'tokenIES',
    )}`;
  }

  async changePass(formData): Promise<any> {
    const email = localStorage.getItem('NPSemailIES') as string;

    const body = {
      email: email,
      senhaAtual: formData.pass,
      senhaNova: formData.newPass,
    };

    const resp = await this.http
      .post(`${process.env.REACT_APP_TROCAR_SENHA}/trocar-senha-usuario`, body)
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }
  // https://tst-api.fundacred.org.br/documents-api/perfil-usuarios/salvar
  async postUserImage(
    name?: string,
    lastName?: string,
    file?: File,
  ): Promise<any> {
    const formData = new FormData();
    file && formData.append('file', file);
    name !== '' && name && formData.append('name', name);
    lastName !== '' && lastName && formData.append('lastName', lastName);

    const resp = await this.http
      .post(`${this.documentApi}/perfil-usuarios/salvar`, formData, {
        timeout: 300000,
      })
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }

  async getUserImage(userId: number) {
    const resp = await this.http
      .get(`${this.documentApi}/perfil-usuarios/foto-perfil/${userId}`, {
        responseType: 'blob',
      })
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }

  //https://tst-api.fundacred.org.br/user-session-api/usuarios-ies/perfil/verificar

  async getUserInfo() {
    const resp = await this.http
      .get(`${this.userSession}/usuarios-ies/perfil/verificar`)
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }
}

export default new UserInfoService();
